export default __webpack_public_path__ + "locales/es/DeleteDialog.json?hash=e345ce4fc4665ef729467793cf332d27";